import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { StickyTable } from 'datastake-daf/dist/components';
import { openDSWindow } from '../../helpers/Window';

const Style = styled.div`
  .ant-table-placeholder {
    display: none;
  }

  .placeholder {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    padding: var(--size);
    background: #FDFDFD;

    img {
      width: 70px;
      margin-left: auto;
      margin-right: auto;
    }

    label{ 
      margin-bottom: 0px;
      color: #595959;
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

const getColumns = (t, mod, mode = 'app') => [
  {
    title: t('ID'),
    key: 'id',
    dataIndex: 'id',
    sorter: (a, b) => (a.id || '').localeCompare(b.id || ''),
    render: (a) => mode === 'app' ? (
      <Link
        to={`/app/${mod}/view/event/${a}`}
        target="_blank"
      >
        {a}
      </Link>
    ) : (
      <a
        href="#"
        onClick={() => {
          openDSWindow({
            url: `/proxy/${mod}/view/event/${a}`,
            name: `Event ${a}`,
          })
        }}
      >
        {a}
      </a>
    ),
    ellipsis: true,
  },
  {
    title: t('Title'),
    key: 'title',
    dataIndex: 'title',
    ellipsis: true,
    sorter: (a, b) => (a.title || '').localeCompare(b.title || ''),
  },
  {
    title: t('Location'),
    key: 'location',
    dataIndex: 'location',
    sorter: (a, b) => (a.location || '').localeCompare(b.location || ''),
    ellipsis: true,
  },
  {
    title: t('Date'),
    key: 'dateOfEvent',
    dataIndex: 'dateOfEvent',
    sorter: (a, b) => moment(a.dateOfEvent).diff(moment(b.dateOfEvent)),
    render: (date) => moment(date).format('DD MMM YYYY'),
    ellipsis: true,
  },
];

const ActionsTable = ({
  actions = [],
  t = (s) => s,
}) => {
  const { pathname } = useLocation();
  const mode = isProxy() ? 'proxy' : 'app';
  const [, mo] = mode === 'app' ?
    pathname.split(/\/app\/(pme|cadd)\/(view|edit)/) :
    pathname.split(/\/proxy\/(pme|cadd)\/(view|edit)/);
  const mod = mo || 'pme';
  const colums = getColumns(t, mod, mode);

  return (
    <Style>
      <StickyTable
        columns={colums}
        dataSource={actions}
        size="small"
        pagination={false}
      />
      {actions.length === 0 && (
        <div className="placeholder">
          <img alt="Empty" src="/assets/images/dashboard/scl-icons/empty-gallery.svg" />
          <label>{t('No actions have been associated ')}</label>
        </div>
      )}
    </Style>
  );
};

export default ActionsTable;
